module.exports = __webpack_public_path__ + "static/media/team-1.a9618a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutUs/image/team-1.jpg
// module id = 435
// module chunks = 0